import { makeStyles } from "@material-ui/core";
import { colors } from "@chhjit/react-components";

export const useAddressFieldsStyles = makeStyles(() => ({
  showAddressFields: {
    color: colors.primary.dark,
  },
}));
